module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G0ynUp/image/adulting-cov-1.jpg",
      "alt": "This image is the cover for the book Unfuck Your Adulting, Five Minute Therapy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unfuck Your Adulting, Five Minute Therapy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dr. Faith explains the fundamentals of adulting in this handy guide. Spoiler: None of the requirements are about having certain jobs, kids, possessions and debts, or being totally bored and stressed out and hating your life. This book will not teach you to change your oil or fold fitted sheets. Instead, Dr. Faith offers wisdom from her life experience and counseling practice like, “If it’s not yours, don’t touch it,” “Love people but not their bullshit,” “Invest in small comforts,” and “Either win or learn.” It’s hard work to do adulty stuff well, but the kind of work that’s satisfying because it’s about being good to yourself and other people and building a life that you’re okay with waking up to every day. Keep these hot tips around for when you’re making big decisions, dealing with difficult situations, or to give to a friend or kid who’s making any kind of big life transition. The truth is, adulting is way more fun than kidding. You got this!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Faith Harper PhD\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Faith Harper, PhD, LPC-S, ACS, ACN is a bad-ass, funny lady with a PhD. She’s a licensed professional counselor, board supervisor, certified sexologist, and applied clinical nutritionist with a private practice and consulting/training business in San Antonio, TX. She has been an adjunct professor and a TEDx presenter, and proudly identifies as a woman of color and uppity intersectional feminist. She is the author of several highly popular “five-minute therapy” zines on subjects such as anxiety, depression, and grief.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e89f29b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0